import { render, staticRenderFns } from "./Tabelle.vue?vue&type=template&id=45f3f64e"
import script from "./Tabelle.vue?vue&type=script&lang=ts"
export * from "./Tabelle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports